import { render, staticRenderFns } from "./SelectDirection.vue?vue&type=template&id=1f6e5412&"
import script from "./SelectDirection.vue?vue&type=script&lang=js&"
export * from "./SelectDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports